export const ORIGENES_OPORTUNIDAD = [
  { id: "cliente_solicita", label: "Cliente solicita" },
  { id: "seguimiento", label: "Seguimiento" },
  { id: "soporte", label: "Soporte" },
  { id: "vendedor_detecta", label: "Vendedor detecta" },
  { id: "renovacion", label: "Renovación" },
  { id: "referido_interno", label: "Referido interno" },
  { id: "campana", label: "Campaña" },
  { id: "otro", label: "Otro" },
];

const ORIGEN_IDS = new Set(ORIGENES_OPORTUNIDAD.map((o) => o.id));

export const TIPOS_OPORTUNIDAD = [
  { id: "primera_venta", label: "Primera venta" },
  { id: "nueva_solucion", label: "Nueva solución" },
  { id: "upsell", label: "Upsell" },
  { id: "cross_sell", label: "Cross-sell" },
  { id: "ampliacion", label: "Ampliación" },
  { id: "renovacion", label: "Renovación" },
  { id: "otro", label: "Otro" },
];

export const ETAPAS_EXPANSION = [
  "interes_detectado",
  "descubrimiento",
  "calificada",
  "propuesta",
  "negociacion",
  "ganada",
  "perdida",
  "pospuesta",
];

export const ETAPAS_EXPANSION_ABIERTAS = [
  "interes_detectado",
  "descubrimiento",
  "calificada",
  "propuesta",
  "negociacion",
];

export const ETAPAS_EXPANSION_KANBAN = [
  "interes_detectado",
  "descubrimiento",
  "calificada",
  "propuesta",
  "negociacion",
  "ganada",
];

export const ETAPAS_EXPANSION_ARCHIVO = ["perdida", "pospuesta"];

export const ETAPAS_MADURAS_SIN_MONTO = ["propuesta", "negociacion"];

export const LABEL_ETAPA_EXPANSION = {
  interes_detectado: "Interés",
  descubrimiento: "Descubrimiento",
  calificada: "Calificada",
  propuesta: "Propuesta",
  negociacion: "Negociación",
  ganada: "Ganada",
  perdida: "Perdida",
  pospuesta: "Pospuesta",
};

export const labelTipoOportunidad = (id) =>
  TIPOS_OPORTUNIDAD.find((t) => t.id === id)?.label || id || "—";

export const labelOrigenOportunidad = (id) =>
  ORIGENES_OPORTUNIDAD.find((o) => o.id === id)?.label || id || "—";

export const esOrigenOportunidadValido = (id) => ORIGEN_IDS.has(id);

/** Migra texto libre legacy en `origen` hacia id + detalleOrigen. */
export function normalizarOrigenOportunidad(opp) {
  if (!opp) return { origen: "", detalleOrigen: "" };
  const detallePrevio = String(opp.detalleOrigen || "").trim();
  const raw = String(opp.origen || "").trim();
  if (!raw) {
    return { origen: "", detalleOrigen: detallePrevio };
  }
  if (ORIGEN_IDS.has(raw)) {
    return { origen: raw, detalleOrigen: detallePrevio };
  }
  const detalleOrigen = detallePrevio
    ? detallePrevio
    : raw;
  return { origen: "otro", detalleOrigen };
}

export const labelEtapaExpansion = (id) => LABEL_ETAPA_EXPANSION[id] || id || "—";

export const oportunidadEstaAbierta = (opp) =>
  ETAPAS_EXPANSION_ABIERTAS.includes(opp?.etapa);
